import React, { useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosInstance';
import { Mail, Trash2, Calendar, User, MessageSquare } from 'lucide-react';

const AdminContacts = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMessages = async () => {
    try {
      const { data } = await axiosInstance.get('/contact'); // Uses the GET route we created
      setMessages(data);
    } catch (error) {
      console.error('Failed to fetch messages', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const handleDelete = async (id) => {
    if(!window.confirm("Delete this message?")) return;
    try {
      await axiosInstance.delete(`/contact/${id}`);
      fetchMessages(); // Refresh list
    } catch (error) {
      console.error("Failed to delete", error);
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6 text-gray-200">
      
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
         <div className="p-3 bg-blue-600/20 rounded-lg text-blue-400">
            <Mail size={32} />
         </div>
         <div>
            <h1 className="text-3xl font-bold text-white">Inbox / Inquiries</h1>
            <p className="text-gray-400 text-sm">Manage incoming contact form submissions.</p>
         </div>
      </div>

      {loading ? (
        <div className="text-center py-10 text-gray-500">Loading messages...</div>
      ) : messages.length === 0 ? (
        <div className="bg-gray-800 p-10 rounded-xl text-center border border-gray-700">
           <Mail size={48} className="mx-auto text-gray-600 mb-4"/>
           <p className="text-gray-400">No messages received yet.</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {messages.map((msg) => (
            <div key={msg.id} className="bg-gray-800 border border-gray-700 rounded-xl p-6 hover:border-blue-500/50 transition-colors shadow-lg relative group">
               
               {/* Header Row */}
               <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
                  <div className="flex items-center gap-3">
                     <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-400">
                        <User size={20} />
                     </div>
                     <div>
                        <h3 className="font-bold text-white text-lg">{msg.name}</h3>
                        <a href={`mailto:${msg.email}`} className="text-sm text-blue-400 hover:underline block">{msg.email}</a>
                     </div>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-mono">
                     <span className="flex items-center gap-1"><Calendar size={12}/> {new Date(msg.created_at).toLocaleString()}</span>
                     <button 
                        onClick={() => handleDelete(msg.id)}
                        className="p-2 hover:bg-red-900/30 text-gray-600 hover:text-red-400 rounded transition-colors"
                        title="Delete Message"
                     >
                        <Trash2 size={16} />
                     </button>
                  </div>
               </div>

               {/* Content */}
               <div className="pl-14">
                  <h4 className="text-gray-300 font-bold mb-2 flex items-center gap-2">
                     <span className="text-blue-500">Subject:</span> {msg.subject || 'No Subject'}
                  </h4>
                  <div className="bg-gray-900/50 p-4 rounded-lg text-gray-400 text-sm leading-relaxed border-l-2 border-blue-500/30">
                     {msg.message}
                  </div>
               </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminContacts;